import {DateFormatOptions} from "@syncfusion/ej2-base/src/internationalization";

export class InternationalizationDateFormatOptions {
  options: DateFormatOptions = {};

  skeleton(value: string): InternationalizationDateFormatOptions {
    this.options.skeleton = value;
    return this;
  }

  type(value: string): InternationalizationDateFormatOptions {
    this.options.type = value;
    return this;
  }

  format(value: string): InternationalizationDateFormatOptions {
    this.options.format = value;
    return this;
  }

  calendar(value: string): InternationalizationDateFormatOptions {
    this.options.calendar = value;
    return this;
  }

  isServerRendered(value: boolean): InternationalizationDateFormatOptions {
    this.options.isServerRendered = value;
    return this;
  }

  build(): DateFormatOptions {
    return this.options;
  }
}

